import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import createPalette from '@material-ui/core/styles/createPalette';
import { colors } from '@material-ui/core';
const { grey, red, green, yellow, cyan } = colors;

const theme = createMuiTheme(
	/**
	 * @see https://material-ui.com/customization/themes/#theme-configuration-variables
	 */
	{
		// direction: "rtl",
		typography: {
			fontFamily: ['Poppins'].join(','),
		},

		palette: createPalette({
			primary: cyan,
			secondary: red,
			accent: grey,
			error: red,
			success: green,
			inProgress: yellow,
		}),

		/**
		 * @see https://material-ui.com/customization/globals/#default-props
		 */
		props: {
			// Set default elevation to 1 for popovers.
			MuiPopover: {
				elevation: 1,
			},
		},
	}
);

export function MaterialThemeProvider(props) {
	const { children } = props;

	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
